import { render, staticRenderFns } from "./SwichPayIn.vue?vue&type=template&id=675883e1&scoped=true&"
import script from "./SwichPayIn.vue?vue&type=script&lang=js&"
export * from "./SwichPayIn.vue?vue&type=script&lang=js&"
import style0 from "./SwichPayIn.vue?vue&type=style&index=0&id=675883e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675883e1",
  null
  
)

export default component.exports